var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-breadcrumb',{attrs:{"routes":_vm.getRoutes()},scopedSlots:_vm._u([{key:"itemRender",fn:function(ref){
var route = ref.route;
var params = ref.params;
var routes = ref.routes;
var paths = ref.paths;
return [(routes.indexOf(route) === routes.length - 1)?_c('span',[_vm._v("\n            "+_vm._s(route.breadcrumbName)+"\n          ")]):_c('router-link',{attrs:{"to":("" + _vm.basePath + (route.path))}},[_vm._v("\n      "+_vm._s(route.breadcrumbName)+"\n    ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }